import React from 'react';
import { BlogSection } from '../components/BlogSection';
export function BlogPage() {
  return <div className="pt-28" data-id="element-489">
      <BlogSection data-id="element-490" />
    </div>;
}